import httpInst from '../utilis/httpService';

const statusService = {

	getOnlineStatus: async () => {
		const http = httpInst();
		const res = await http({
			method: 'get',
			url: `/get-offline-status`,
		});
		return res.data;
	},

	setOnlineStatus: async (isOffline) => {
		const http = httpInst();
		const res = await http({
			method: 'post',
			url: `/change-offline-status`,
			data: {
				isOffline: isOffline,
			},
		});

		return res.data;
	},

}

export default statusService;